import { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { BonusWallet } from "@/widgets/bonus-wallet"
import { Loader } from "@/shared/ui/loader"
import { getSocialProgramById, getSocialProgramWallet, ISocialProgram } from "@/shared/api/social-programs"
import { IWalletBalance } from "@/shared/types"
import { selectBonuses, selectBonusesLoading } from "@/entities/bonus"
import { useAppSelector } from "@/shared/lib/redux"
import notify from "@/shared/lib/notify"

export const SocialProgramWalletPage = () => {
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const allBonuses = useAppSelector(selectBonuses)
    const bonusesLoading = useAppSelector(selectBonusesLoading)

    const [program, setProgram] = useState<ISocialProgram | null>(null)
    const [wallet, setWallet] = useState<IWalletBalance>({})
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (!id) return
        setIsLoading(true)
        Promise.all([
            getSocialProgramById(id),
            getSocialProgramWallet(id),
        ])
            .then(([programRes, walletRes]) => {
                setProgram(programRes.data)
                setWallet(walletRes.data)
            })
            .catch(() => notify.error('Не удалось загрузить данные'))
            .finally(() => setIsLoading(false))
    }, [id])

    const bonuses = allBonuses.filter(b => b.id in wallet)

    if (isLoading) {
        return (
            <div className="_page_container">
                <PageHeader title="Кошелёк" />
                <div className="info_panel"><Loader /></div>
            </div>
        )
    }

    return (
        <div className="_page_container">
            <PageHeader title={program ? `${program.name} — Кошелёк` : 'Кошелёк'} />
            <div className="flexbox">

                <button
                    onClick={() => navigate(`/social-programs/${id}`)}
                    className="flex items-center gap-1 text-sm font-semibold text-color-dark self-start"
                >
                    ← Назад к программе
                </button>

                <PageSubtitle title="Кошелёк" />
                <BonusWallet bonuses={bonuses} bonusesLoading={bonusesLoading} wallet={wallet} />

            </div>
        </div>
    )
}
